import logo from '../images/logo.svg';

export default function Logo() {
    return (
        <img src={logo} className="App-logo" alt="Default React Atom Logo" />
    )
}